var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotif(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notif",
    transform: "translate(-4540 -1778)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11305",
    "data-name": "Group 11305",
    transform: "translate(5965 161)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "bell",
    transform: "translate(-1425 1617)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "bell-2",
    "data-name": "bell",
    d: "M70,37h4a2,2,0,1,1-4,0Zm-7-1a1,1,0,0,1-1-1V32a1,1,0,0,1,.553-.9L64,30.381V25a8,8,0,1,1,16,0v5.381l1.447.724A1,1,0,0,1,82,32v3a1,1,0,0,1-1,1Zm3-11v6a1,1,0,0,1-.553.895L64,32.618V34H80V32.618l-1.447-.724A1,1,0,0,1,78,31V25a6,6,0,0,0-12,0Z",
    transform: "translate(-60 -16)",
    fill: "#fff",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9795",
    "data-name": "Rectangle 9795",
    width: 24,
    height: 24,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2804",
    "data-name": "Ellipse 2804",
    cx: 4,
    cy: 4,
    r: 4,
    transform: "translate(4554 1780)",
    fill: "#00A8FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotif);
export default __webpack_public_path__ + "static/media/notif.796f60aab90e0600b5faaa889e399472.svg";
export { ForwardRef as ReactComponent };